
if (!customElements.get('modal-dialog')) {
  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.modal = this.querySelector('.modal');
      this.modalContent = this.querySelector('.modal-content');
      this.closeButton = this.querySelector('.modal-close');
    }

    connectedCallback() {
      // This runs when the element is added to the DOM
      this.init();
    }

    init() {
      // Get modal triggers after the element is connected to DOM
      this.modalTriggers = document.querySelectorAll(`[data-modal-trigger="${this.id}"], a[href*="#${this.id}"]`);
      // Bind event listeners
      this.bindEvents();
    }

    bindEvents() {
      // Bind trigger buttons
      this.modalTriggers?.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          if (e.target.nodeName === 'A') {
            e.stopPropagation();
          }
          this.open();
        })
      })

      // Close button click
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.close());
      }

      // Click outside modal to close
      if (this.modal) {
        this.modal.addEventListener('click', (e) => {
          if (e.target === this.modal) {
            this.close();
          }
        });
      }

      // Prevent modal content clicks from closing modal
      if (this.modalContent) {
        this.modalContent.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }

      // ESC key to close
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.close();
        }
      });

      // Form submission handling
      if (this.form) {
        this.form.addEventListener('submit', (e) => this.handleFormSubmit(e));
      }
    }

    open() {
      this.modal.classList.add('open');
      
      // Generate shared cart URL if cart link field exists
      const cartLinkField = this.querySelector('#sharecartCartLink');
      if (cartLinkField) {
        this.generateSharedCartUrl().then(url => {
          cartLinkField.value = url;
        });
      }

      // Trigger custom event
      this.dispatchEvent(new CustomEvent('modal:opened', { bubbles: true }));
    }

    close() {
      this.modal.classList.remove('open');
      
      // Trigger custom event
      this.dispatchEvent(new CustomEvent('modal:closed', { bubbles: true }));
    }

    isOpen() {
      return this.style.display === 'block';
    }

    handleFormSubmit(e) {
      // You can add form validation here if needed
      // For now, let the form submit naturally
      
      // Trigger custom event
      this.dispatchEvent(new CustomEvent('modal:formSubmit', { 
        bubbles: true, 
        detail: { form: this.form } 
      }));
    }

    // Method to populate form fields programmatically
    setFormData(data) {
      Object.keys(data).forEach(key => {
        const input = this.querySelector(`[name="${key}"]`);
        if (input) {
          input.value = data[key];
        }
      });
    }

    // Method to reset form
    resetForm() {
      if (this.form) {
        this.form.reset();
      }
    }

    // Method to generate shared cart URL from current cart
    async generateSharedCartUrl() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        if (!cart.items || cart.items.length === 0) {
          return window.location.origin + '/?shared-cart=true&items=';
        }
        
        const itemsParam = cart.items.map(item => `${item.variant_id}:${item.quantity}`).join(',');
        const baseUrl = window.location.origin;
        
        return `${baseUrl}/cart/?shared-cart=true&items=${itemsParam}`;
      } catch (error) {
        console.error('Error generating shared cart URL:', error);
        return window.location.origin + '/cart/?shared-cart=true&items=';
      }
    }
  }

  // Register the custom element
  customElements.define('modal-dialog', ModalDialog);
}